import { PopupModal, useCalendlyEventListener } from 'react-calendly'
import { notifications } from '@mantine/notifications'

import { isApiError } from '@/types/apiErrors.types'

import type { CreateEventModalProps } from '@/modules/advisorsPage/components/CreateEventModal/CreateEventModal.types'

import { useUserStore } from '@/store/user.store'

import { Loader } from '@/components/Loader/Loader'

import { FORM_MESSAGES_MAP } from '@/constants/formMessages.constants'

import { useAppointmentsServiceAppointmentsControllerCreateAppointment } from '@/__generated__/queries'

export function CreateEventModal({
  advisor,
  containerRef,
  onClose,
  opened,
}: CreateEventModalProps) {
  const user = useUserStore.use.user()
  const setUser = useUserStore.use.setUser()

  const createEventMutation =
    useAppointmentsServiceAppointmentsControllerCreateAppointment({
      onError: error => {
        let errorMessage = FORM_MESSAGES_MAP.UNKNOWN_ERROR

        if (isApiError(error)) {
          errorMessage = error.body.message || errorMessage
        }

        onClose()

        notifications.show({
          color: 'red',
          message: errorMessage,
          title: 'Error creating event',
        })
      },
      onSuccess: () => {
        if (user?.id) {
          setUser({
            ...user,
            appointmentsCount: user.appointmentsCount
              ? user.appointmentsCount + 1
              : 1,
          })
        }
      },
    })

  useCalendlyEventListener({
    onEventScheduled: event => {
      const { payload } = event.data
      const eventUriArray = payload.event.uri.split('/')

      const appointmentId = eventUriArray[eventUriArray.length - 1]

      createEventMutation.mutate({
        requestBody: {
          advisorId: advisor.id,
          calendlyId: appointmentId,
        },
      })
    },
  })

  if (!containerRef.current) return null

  return (
    <PopupModal
      LoadingSpinner={() => <Loader isMinimized />}
      onModalClose={onClose}
      open={opened}
      pageSettings={{
        hideLandingPageDetails: true,
      }}
      prefill={{
        email: user?.email,
        name: `${user?.firstName} ${user?.lastName}`,
      }}
      rootElement={containerRef.current}
      url={`${advisor.calendly}/${import.meta.env.VITE_CALENDLY_EVENT_TYPE_NAME}`}
    />
  )
}
